export const NAME = "core-init";
